import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedGridPattern } from '../../ui/animated-grid-pattern';
import { cn } from "../../../lib/utils";
import './IntroSectionHome.css';
import { FeaturesSectionWithHoverEffects } from '../../ui/feature-section-with-hoover-effect';
import CloudArchitectureImg from '../../../assets/images/logo-landing-itmonkeys-grey.png';
import { homePageFeatures } from '../../../data/features';
import { TextGradientScroll } from '../../ui/text-gradient-scroll';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';

const IntroSectionHome: React.FC = () => {
  const { t } = useTranslation();

      const homeStats = [
        {
          value: '20 ans',
          label: 'D\'expérience terrain',
          translationKey: 'home.stats.experience',
          labelTranslationKey: 'home.stats.experienceLabel'
        },
        {
          value: '500+',
          label: 'Clients satisfaits',
          translationKey: 'home.stats.clients',
          labelTranslationKey: 'home.stats.clientsLabel'
        },
        {
          value: '24/7',
          label: 'Protection',
          translationKey: 'home.stats.support',
          labelTranslationKey: 'home.stats.supportLabel'
        },
        {
          value: '100%',
          label: 'Solutions sur mesure',
          translationKey: 'home.stats.custom',
          labelTranslationKey: 'home.stats.customLabel'
        }
      ];
  
  return (
      <div className="intro-section-home">
      <div className="container-max-width tw-relative tw-flex tw-h-[500px] tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-border tw-bg-background tw-md:pt-20 tw-md:shadow-xl">
      <div className="centered-title-top">
      <h2 style={{ paddingRight: '0px' }}>{t('home.hero.title')}</h2>
      <h3 className='infra-title-subtitle'>{t('home.hero.subtitle1')}</h3>
      <div className="title-image-container">
        <img src={CloudArchitectureImg} alt={t('home.architecture.alt')} className="title-below-image overflow-visible" />
      </div>
      </div>
      <AnimatedGridPattern
        numSquares={30}
        maxOpacity={0.1}
        duration={3}
        repeatDelay={1}
        className={cn(
          "[mask-image:radial-gradient(500px_circle_at_center,white,transparent)]",
          "tw-inset-x-0 tw-inset-y-[-30%] tw-h-[200%] tw-skew-y-12",
        )}
      />
    </div>

        <div className="container-max-width tw-w-full tw-flex tw-flex-col tw-mt-8 tw-mt-[-8em] tw-mb-[2em]">
          <div className="tw-w-full tw-mt-[7em]">
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[42%_1fr] tw-gap-8 tw-items-center">
              <div className="tw-relative tw-h-[31em] max-[734px]:tw-hidden tw-flex tw-justify-center lg:tw-justify-start" style={{ borderTopLeftRadius: '100px' }}>
                <div
                  aria-hidden="true"
                  className="tw-absolute tw-inset-0 tw-pointer-events-none tw-z-0"
                  style={{ borderTopLeftRadius: '100px' }}
                >
                  <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-[#24bbd9]/20 tw-via-[#4166bc]/10 tw-to-transparent" style={{ borderTopLeftRadius: '100px' }} />
                  <div className="tw-absolute -tw-top-10 -tw-left-10 tw-h-64 tw-w-64 tw-rounded-full tw-bg-[#24bbd9]/20 tw-blur-3xl tw-opacity-60" style={{ borderTopLeftRadius: '100px' }} />
                </div>
              </div>

              <div className="max-[734px]:tw-hidden">
                <div className="intro-text-2" style={{ maxWidth: '100%' }}>
                  <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('home.publicCible.title', 'Notre mission')}</h2>
                  <h3 className="public-cible-description">{t('home.publicCible.description', 'Incarner un pôle d\'excellence unique pour protéger vos entreprises et assurer leur pérennité à long terme.')}</h3>
                </div>
                <FeaturesSectionWithHoverEffects
                  limit={4}
                  displayInRow={true}
                  featuresData={homePageFeatures}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container-max-width intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0 max-[734px]:tw-hidden">
          <div className="intro-text-1">
            <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('home.stats.title', 'Notre engagement')}</h2>
          </div>
        </div>

        <div className="max-[734px]:tw-hidden">
          <FeaturedSectionStats
            title={t('home.introSectionHome.featuredTitle')}
            subtitle={t('home.introSectionHome.featuredSubtitle')}
            titleTranslationKey="home.stats.title"
            subtitleTranslationKey="home.stats.subtitle"
            stats={homeStats}
            showChart={false}
          />
        </div>
  </div>
  );
};

export default IntroSectionHome;
